class FreeShipping extends SearchForm {
  constructor() {
    super();

    this.conversionRate = parseFloat(Shopify.currency.rate) || 1;

    this.amount = parseInt(this.dataset.amount) || 0;

    this.baseThreshold = parseInt(this.dataset.threshold) || 0;
    this.threshold = this.baseThreshold * this.conversionRate;

    this.baseGiftThresholds = this.parseGiftThresholds();

    this.giftThresholds = this.baseGiftThresholds.map(
      (value) => value * this.conversionRate
    );

    this.hasGift = this.giftThresholds.length > 0;

    this.progressBar = this.querySelector('[data-progress-bar]');
    this.freePoint = this.querySelector('[data-free-point]');
    this.giftPoints = this.querySelectorAll('[data-gift-point]');

    this.met = this.querySelector('[data-free-shipping="true"]');
    this.unmet = this.querySelector('[data-free-shipping="false"]');

    this.amountText = this.querySelector('[data-amount]');
    this.giftAmountTexts = this.querySelectorAll('[data-gift-message] [data-amount2]');

    this.update();
    this.classList.add('free-shipping--active');
  }

  parseGiftThresholds() {
    const list = this.getAttribute('data-gift-thresholds');
    if (list) {
      return list
        .split(',')
        .map((value) => parseInt(value.trim(), 10))
        .filter((value) => value > 0);
    }

    return [
      parseInt(this.getAttribute('data-gift-threshold'), 10) || 0,
      parseInt(this.getAttribute('data-gift-threshold-2'), 10) || 0,
      parseInt(this.getAttribute('data-gift-threshold-3'), 10) || 0,
    ].filter((value) => value > 0);
  }

  update() {
    this.updateProgress();
    this.updateShippingState();
  }

  getProgressMax() {
    const values = [this.threshold, ...this.giftThresholds];
    return Math.max(...values, 1);
  }

  updateProgress() {
    if (!this.progressBar) return;

    const max = this.getProgressMax();
    const percent = Math.min(this.amount / max, 1) * 100;

    const bar = this.progressBar.querySelector('.progress-bar');
    if (bar) {
      bar.style.width = `${percent}%`;
    }

    this.updatePoints(max);
  }

  positionPoint(point, percent) {
    const clamped = Math.min(Math.max(percent, 0), 100);
    point.style.left = `${clamped}%`;

    if (clamped <= 3) {
      point.style.transform = 'translateX(0)';
    } else if (clamped >= 97) {
      point.style.transform = 'translateX(-100%)';
    } else {
      point.style.transform = 'translateX(-50%)';
    }
  }

  updatePoints(max) {
    if (this.freePoint) {
      const freePercent = (this.threshold / max) * 100;
      this.positionPoint(this.freePoint, freePercent);
      this.freePoint.classList.toggle('active', this.amount >= this.threshold);
    }

    this.giftPoints.forEach((point, index) => {
      const giftThreshold = this.giftThresholds[index];

      if (!giftThreshold) {
        point.style.display = 'none';
        point.classList.remove('active');
        return;
      }

      point.style.display = 'flex';
      const giftPercent = (giftThreshold / max) * 100;
      this.positionPoint(point, giftPercent);
      point.classList.toggle('active', this.amount >= giftThreshold);
    });

    // Hide extra DOM nodes if markup and thresholds ever drift
    for (let i = this.giftThresholds.length; i < this.giftPoints.length; i += 1) {
      this.giftPoints[i].style.display = 'none';
      this.giftPoints[i].classList.remove('active');
    }
  }

  getNextGiftThreshold() {
    for (const giftThreshold of this.giftThresholds) {
      if (this.amount < giftThreshold) return giftThreshold;
    }
    return null;
  }

  formatMoney(value) {
    const locale = document.documentElement.getAttribute('lang');
    if (!Shopify.currency.active) return String(value);

    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: Shopify.currency.active,
    }).format(value);
  }

  updateGiftAmountDisplays() {
    if (!this.hasGift || !this.giftAmountTexts.length) return;

    const nextGiftThreshold = this.getNextGiftThreshold();
    if (!nextGiftThreshold) {
      this.giftAmountTexts.forEach((el) => {
        el.textContent = '';
      });
      return;
    }

    const remainingGift = Math.max((nextGiftThreshold - this.amount) / 100, 0);
    const formatted = this.formatMoney(remainingGift);

    this.giftAmountTexts.forEach((el) => {
      el.textContent = formatted;
    });
  }

  updateShippingState() {
    if (!this.met || !this.unmet) return;

    const locale = document.documentElement.getAttribute('lang');

    if (this.amount >= this.threshold) {
      this.met.removeAttribute('aria-hidden');
      this.unmet.setAttribute('aria-hidden', 'true');
    } else {
      this.met.setAttribute('aria-hidden', 'true');
      this.unmet.removeAttribute('aria-hidden');

      if (Shopify.currency.active && this.amountText) {
        const remaining = (this.threshold - this.amount) / 100;

        this.amountText.textContent = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency: Shopify.currency.active,
        }).format(remaining);
      }
    }

    this.updateGiftAmountDisplays();
  }
}

customElements.define('free-shipping', FreeShipping);
